export class GeocodingError extends Error {
  constructor(message) {
    super(message);
    this.type = 'geocoding_error';
  }
}

export class ValidationError extends Error {
  constructor(message) {
    super(message);
    this.type = 'validation_error';
  }
}